import { _backgroundGradient } from "../utils/_backgroundGradient";
import { _fibonacci } from "../utils/_fibonacci";
import { _section } from "../utils/_section";
import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass";
import { _homePageUniforms } from "./Masthead";

class Footer extends MainClass {
    background: _backgroundGradient | null;

    constructor(props: MAIN_CLASS_PARAMS) {
        super(props);

        this.background = null;

        this.init();
    }

    init() {
        // for fibonacci line
        new _fibonacci({ target: this.selector, type: 3 });

        // for bg-gradient
        if (!_section.bodyGradient())
            this.background = new _backgroundGradient({ target: this.selector, uniforms: _homePageUniforms });
    }
}

export default Footer;
